import {JourneyProgressSegment} from "./JourneyProgressSegment";
import type {JourneyProgressStage} from "./types";

export function JourneyProgressBar({stages}: {stages: readonly JourneyProgressStage[]}) {
    if (stages.length === 0) {
        return null;
    }

    return (
        <div className="flex w-full min-w-0 items-start gap-x-ds-space-050">
            {stages.map((stage) => (
                <JourneyProgressSegment
                    key={stage.id}
                    label={stage.label}
                    state={stage.state}
                />
            ))}
        </div>
    );
}
